/* eslint-disable no-unsafe-optional-chaining */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../components";
import "./ManageAssignmentsModal.scss";

const ManageAssignmentsModal = props => {
	const { lang } = global;
	const {
		show,
		onHide,
		assignmentRules,
		staggeredRules,
		handleRuleDelete,
		handleRuleEdit,
		handleStaggeredRuleEdit,
		handleStaggeredRuleDelete,
	} = props;

	const [activeTab, setActiveTab] = useState("assignment-rules");
	const [assignmentFilter, setAssignmentFilter] = useState("");
	const [staggeredFilter, setStaggeredFilter] = useState("");
	const [filteredAssignmentRules, setFilteredAssignmentRules] = useState([]);
	const [filteredStaggeredRules, setFilteredStaggeredRules] = useState([]);
	const [sortAssignmentRulesAsc, setSortAssignmentRulesAsc] = useState(true);

	useEffect(() => {
		const auxList = [...assignmentRules].sort((a, b) =>
			a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()),
		);
		setFilteredAssignmentRules(auxList);
	}, [assignmentRules]);

	useEffect(() => {
		const auxList = [...staggeredRules].sort((a, b) =>
			a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()),
		);
		setFilteredStaggeredRules(auxList);
	}, [staggeredRules]);

	useEffect(() => {
		setAssignmentFilter("");
		setStaggeredFilter("");
	}, [show]);

	useEffect(() => {
		const filtRules = assignmentRules.filter(x =>
			x.Name.toLowerCase().includes(assignmentFilter.toLowerCase()),
		);
		if (sortAssignmentRulesAsc) {
			filtRules.sort((a, b) => a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()));
		} else {
			filtRules.sort((a, b) => b.Name.toLowerCase().localeCompare(a.Name.toLowerCase()));
		}
		setFilteredAssignmentRules(filtRules);
	}, [assignmentFilter]);

	useEffect(() => {
		const filtRules = staggeredRules.filter(x =>
			x.Name.toLowerCase().includes(staggeredFilter.toLowerCase()),
		);
		if (sortAssignmentRulesAsc) {
			filtRules.sort((a, b) => a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()));
		} else {
			filtRules.sort((a, b) => b.Name.toLowerCase().localeCompare(a.Name.toLowerCase()));
		}
		setFilteredStaggeredRules(filtRules);
	}, [staggeredFilter]);

	const assignmentFilterChanged = e => {
		setAssignmentFilter(e.target.value);
	};

	const staggeredFilterChanged = e => {
		setStaggeredFilter(e.target.value);
	};

	const sortAssignmentRules = () => {
		const filtRules = [...filteredAssignmentRules];
		const filtRulesSt = [...filteredStaggeredRules];
		if (!sortAssignmentRulesAsc) {
			filtRules.sort((a, b) => a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()));
			filtRulesSt.sort((a, b) => a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()));
		} else {
			filtRules.sort((a, b) => b.Name.toLowerCase().localeCompare(a.Name.toLowerCase()));
			filtRulesSt.sort((a, b) => b.Name.toLowerCase().localeCompare(a.Name.toLowerCase()));
		}
		setFilteredAssignmentRules(filtRules);
		setFilteredStaggeredRules(filtRulesSt);
		setSortAssignmentRulesAsc(prev => !prev);
	};

	return (
		<Modal
			id="manage-assignment-modal"
			dialogClassName="manage-assignment-dialog"
			size="md"
			show={show}
			onHide={() => onHide()}
		>
			<Modal.Header
				closeButton
				className="hidden-print"
			>
				<Modal.Title>{lang.t("Manage Posting")}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="container-fluid">
				<div>
					<ul
						className="row nav tabs"
						role="presentation"
					>
						<li
							role="presentation"
							className={`col-xs-5 col-xs-offset-1 col-sm-3 col-sm-offset-3${
								activeTab === "assignment-rules" ? " active" : ""
							}`}
						>
							<button
								type="button"
								role="tab"
								name="assignment-rules-tab"
								className="btn-block"
								onClick={() => setActiveTab("assignment-rules")}
							>
								{lang.t("Posting Rules")}
							</button>
						</li>
						<li
							role="presentation"
							className={`col-xs-5 col-sm-3${activeTab === "staggered" ? " active" : ""}`}
						>
							<button
								type="button"
								role="tab"
								name="staggered-assignment-tab"
								style={{ whiteSpace: "nowrap" }}
								className="btn-block"
								onClick={() => setActiveTab("staggered")}
							>
								{lang.t("Staggered Posting")}
							</button>
						</li>
					</ul>
				</div>
				<If condition={activeTab === "assignment-rules"}>
					<div className="actions-container">
						<input
							className="form-control"
							placeholder="Search..."
							value={assignmentFilter}
							onChange={e => assignmentFilterChanged(e)}
						/>
						<button
							type="button"
							id="add-new-group"
							className="btn btn-link"
							onClick={() => handleRuleEdit()}
						>
							{`+ ${lang.t("Create New Posting Rule")}`}
						</button>
					</div>
					<div className="row assignment-row">
						<div
							className="col-xs-8 col-sm-9"
							role="button"
							onClick={() => sortAssignmentRules()}
							style={{ lineHeight: "32px" }}
							tabIndex="0"
							onKeyPress={({ key }) => {
								if (key === "Enter") sortAssignmentRules();
							}}
						>
							<strong style={{ marginRight: "10px" }}>Rule Name</strong>
							<If condition={sortAssignmentRulesAsc}>
								<i className="glyphicon glyphicon-triangle-bottom" />
							</If>
							<If condition={!sortAssignmentRulesAsc}>
								<i className="glyphicon glyphicon-triangle-top" />
							</If>
						</div>
					</div>
					<For
						each="rule"
						of={filteredAssignmentRules}
					>
						<div
							className="row assignment-row"
							key={`assignment-group-${rule.Id}`}
							// eslint-disable-next-line no-unsafe-optional-chaining
							style={
								filteredAssignmentRules?.findIndex(
									ruleAux => ruleAux.Id === rule.Id,
								) %
									2 ===
								0
									? { background: "#f0f0f0" }
									: { background: "white" }
							}
						>
							<div
								className="col-xs-8 col-sm-9"
								style={{ lineHeight: "32px" }}
							>
								{rule.Name}
							</div>
							<div className="col-xs-2 col-sm-1 col-sm-offset-1 text-center">
								<button
									type="button"
									className="btn btn-link"
									onClick={() => handleRuleEdit(rule.Id)}
								>
									<i className="rkf rkf-pencil" />
								</button>
							</div>
							<div className="col-xs-2 col-sm-1 text-center">
								<button
									type="button"
									className="btn btn-link"
									onClick={() => handleRuleDelete(rule.Id)}
								>
									<i className="rkf rkf-trash text-danger" />
								</button>
							</div>
						</div>
					</For>
				</If>
				<If condition={activeTab === "staggered"}>
					<div className="actions-container">
						<input
							className="form-control"
							placeholder="Search..."
							value={staggeredFilter}
							onChange={e => staggeredFilterChanged(e)}
						/>
						<button
							type="button"
							id="add-new-group"
							className="btn btn-link"
							onClick={() => handleStaggeredRuleEdit()}
						>
							{`+ ${lang.t("Create New Staggered Rule")}`}
						</button>
					</div>
					<div className="row assignment-row">
						<div
							className="col-xs-8 col-sm-9"
							role="button"
							onClick={() => sortAssignmentRules()}
							style={{ lineHeight: "32px" }}
							tabIndex="0"
							onKeyPress={({ key }) => {
								if (key === "Enter") sortAssignmentRules();
							}}
						>
							<strong style={{ marginRight: "10px" }}>Rule Name</strong>
							<If condition={sortAssignmentRulesAsc}>
								<i className="glyphicon glyphicon-triangle-bottom" />
							</If>
							<If condition={!sortAssignmentRulesAsc}>
								<i className="glyphicon glyphicon-triangle-top" />
							</If>
						</div>
					</div>
					<For
						each="rule"
						of={filteredStaggeredRules}
					>
						<div
							className="row assignment-row"
							key={`staggered-group-${rule.Id}`}
							// eslint-disable-next-line no-unsafe-optional-chaining
							style={
								filteredStaggeredRules?.findIndex(
									ruleAux => ruleAux.Id === rule.Id,
								) %
									2 ===
								0
									? { background: "#f0f0f0" }
									: { background: "white" }
							}
						>
							<div
								className="col-xs-8 col-sm-9"
								style={{ lineHeight: "32px" }}
							>
								{rule.Name}
							</div>
							<div className="col-xs-2 col-sm-1 col-sm-offset-1 text-center">
								<button
									type="button"
									className="btn btn-link"
									onClick={() => handleStaggeredRuleEdit(rule.Id)}
								>
									<i className="rkf rkf-pencil" />
								</button>
							</div>
							<div className="col-xs-2 col-sm-1 text-center">
								<button
									type="button"
									className="btn btn-link"
									onClick={() => handleStaggeredRuleDelete(rule.Id)}
								>
									<i className="rkf rkf-trash text-danger" />
								</button>
							</div>
						</div>
					</For>
				</If>
			</Modal.Body>
			<Modal.Footer>
				<button
					id="button-go-back"
					className="btn btn-link hidden-print"
					type="button"
					onClick={() => onHide()}
				>
					{lang.t("Close")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

ManageAssignmentsModal.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func,
	assignmentRules: PropTypes.array.isRequired,
	staggeredRules: PropTypes.array.isRequired,
	handleRuleDelete: PropTypes.func.isRequired,
	handleRuleEdit: PropTypes.func.isRequired,
	handleStaggeredRuleEdit: PropTypes.func.isRequired,
	handleStaggeredRuleDelete: PropTypes.func.isRequired,
};

ManageAssignmentsModal.defaultProps = {
	show: false,
	onHide: () => {},
};

export default ManageAssignmentsModal;
